module.exports = __webpack_public_path__ + "img/top_title_xuchang.b7a3a6e0.png";